export const FETCH_AUDIT_LIST_REQUEST = 'FETCH_TEMPLATE_REQUEST';
export const FETCH_AUDIT_LIST_REQUEST_COMPLETED = 'FETCH_TEMPLATE_REQUEST_COMPLETED';
export const FETCH_AUDIT_LIST_REQUEST_ERROR = 'FETCH_TEMPLATE_REQUEST_ERROR';
export const FETCH_AUDIT_LIST_RESET = 'FETCH_AUDIT_LIST_RESET';


// WEBPACK FOOTER //
// ./constants/auditdetails.js